import { apiAuthClient } from 'shared/api/lib/apiAuthClient';
import type {
  DeleteDocumentRequestTypes,
  DeleteDocumentResponseTypes,
} from '../types';

export const deleteDocument = (params: DeleteDocumentRequestTypes) => {
  const { documentId } = params;

  const url = `/api/v2/documents/${documentId}`;
  return apiAuthClient.delete<DeleteDocumentResponseTypes>(url);
};
